import NewHepForm from './NewHepForm'
import { useGetUsersQuery } from '../users/usersApiSlice'
import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'

const NewHep = () => {
    useTitle('DPE: New HEP')

    const { users } = useGetUsersQuery("usersList", {
        selectFromResult: ({ data }) => ({
            users: data?.ids.map(id => data?.entities[id])
        }),
    })

    if (!users?.length) return <PulseLoader color={"#5f788a"} />

    const content = <NewHepForm users={users} />

    return content
}
export default NewHep